import {Injectable} from "@angular/core";
import {Api, ApiService} from "./api.service";
import {Form} from "../interfaces/form.interface";


@Injectable()
export class HubService {

    public constructor(private apiService: ApiService) {
    }

    public getHubs(query: any = {}): Promise<Api.IResponse> {
        return this.apiService.request(Api.EMethod.Get, ["hub"], {}, query);
    }

}
